import { Button } from 'antd';
import moment from 'moment';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import style from '../dateRangeCalendar.module.scss';

type TProps = {
    weekStart: moment.Moment;
    onPrev: () => void;
    onNext: () => void;
    onToday: () => void;
};

/** Подпись недели: «19 – 25 окт. 2026», на стыке месяцев — оба месяца */
const formatWeek = (weekStart: moment.Moment) => {
    const weekEnd = weekStart.clone().add(6, 'day');
    const startFormat = weekStart.isSame(weekEnd, 'month') ? 'D' : 'D MMM';
    return `${weekStart.locale('ru').format(startFormat)} – ${weekEnd.locale('ru').format('D MMM YYYY')}`;
};

export const WeekNavigator = ({ weekStart, onPrev, onNext, onToday }: TProps) => (
    <div className={style['week-navigator']}>
        <Button
            type="text"
            icon={<FontAwesomeIcon icon={faChevronLeft} />}
            onClick={onPrev}
            aria-label="Предыдущая неделя"
        />
        <button type="button" className={style['week-navigator__title']} onClick={onToday}>
            {formatWeek(weekStart)}
        </button>
        <Button
            type="text"
            icon={<FontAwesomeIcon icon={faChevronRight} />}
            onClick={onNext}
            aria-label="Следующая неделя"
        />
    </div>
);
